module.exports = {"pathContext":{"name":"ImportEntityType","kind":"ENUM","type":"OBJECT","fields":null,"description":"Type of entity being imported from a patient document","enumValues":[{"deprecationReason":null,"description":"Import an immunization","isDeprecated":false,"name":"IMMUNIZATION"},{"deprecationReason":null,"description":"Import a medication","isDeprecated":false,"name":"MEDICATION"},{"deprecationReason":null,"description":"Import a patient protocol","isDeprecated":false,"name":"PATIENT_PROTOCOL"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-import-entity-type.json
// module id = 1254
// module chunks = 40589038282886